/**
 * Additional interface config whitelist extending the original whitelist applied when Jitsi Meet is embedded
 * in another app be that with an iframe or a mobile SDK.
 *
 * 白标：允许嵌入方（Electron External API）覆盖产品名与水印相关项，
 * 避免依赖服务端 interface_config 未部署时仍露出默认品牌名。
 */
export default [
    'APP_NAME',
    'DEFAULT_WELCOME_PAGE_LOGO_URL',
    'JITSI_WATERMARK_LINK',
    'SHOW_BRAND_WATERMARK',
    'SHOW_JITSI_WATERMARK',
    'SUPPORT_URL'
];
